import { getEmailList, getContactName, copyEmail, delEmail } from '@/services/edm'

let statusOptions = [{
  key: -1,
  text: '草稿'
}, {
  key: 1,
  text: '已发送'
}, {
  key: 2,
  text: '已排期'
}, {
  key: 3,
  text: '发送中'
}, {
  key: 4,
  text: '失效'
}]
export default {
  namespaced: true,
  state: {
    tableSort: {},
    sortedInfo: {},
    filteredInfo: {},
    statusOptions,
    defaultColumns: [{
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      slots: { title: 'name' },
      scopedSlots: { customRender: 'name' },
      width: 320
    }, {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      slots: { title: 'status' },
      scopedSlots: { customRender: 'status', filterIcon: 'filterIcon' },
      width: 360,
      filters: []
    },
    {
      title: '最后编辑',
      dataIndex: 'edittime',
      key: 'edittime',
      slots: { title: 'edittime' },
      scopedSlots: { customRender: 'edittime' },
      sorter: true,
      width: 240
    },
    {
      title: '操作',
      dataIndex: 'action',
      slots: { title: 'action' },
      scopedSlots: { customRender: 'action' },
      width: 120
    }],
    listDatas: [],
    contactNames: [],
    pagination: {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    },

    loading: true
  },
  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_TOTAL (state, total) {
      state.pagination.total = total
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_TABLE_SORT (state, { tableSort = {}, sorter = {}, filters = {} }) {
      state.tableSort = Object.assign({}, tableSort)
      state.sortedInfo = sorter
      state.filteredInfo = filters
    },
    SET_CONTACT_NAMES (state, data) {
      state.contactNames = data
    }
  },
  getters: {
    columns (state) {
      const { defaultColumns } = state
      defaultColumns.forEach(item => {
        if (item.sorter) {
          item.sortOrder = state.sortedInfo.columnKey === item.dataIndex && state.sortedInfo.order
        }
        if (item.dataIndex === 'status') {
          item.filters = state.statusOptions.map(option => {
            option.value = option.text
            return option
          })
          item.filteredValue = (state.filteredInfo && state.filteredInfo.status) || []
          /* item.onFilter = (value, record) => {
            return record.text === value
          } */
        }
      })
      return defaultColumns
    }
  },
  actions: {
    async fetchContactName ({ commit }, params) {
      let chain = await getContactName()
      chain
        .params(params)
        .config({ tip: false, warn: false })
        .onSuccess(res => {
          commit('SET_CONTACT_NAMES', res)
        })
        .fetch()
      return chain
    },
    async fetchEmailList ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getEmailList()
      chain
        .params(params)
        .config({ tip: false })
        .onSuccess(res => {
          commit('setListDatas', res.list)
          commit('SET_TOTAL', res.count)
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async copyEmail ({ commit, dispatch }, params) {
      let chain = await copyEmail()
      chain
        .params(params)
        .fetch()
      return chain
    },
    async delEmail ({ commit, dispatch }, params) {
      let chain = await delEmail()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
